import { render } from "./CurrencyToggle.vue?vue&type=template&id=55e8891a&scoped=true"
import script from "./CurrencyToggle.vue?vue&type=script&lang=js"
export * from "./CurrencyToggle.vue?vue&type=script&lang=js"

import "./CurrencyToggle.vue?vue&type=style&index=0&id=55e8891a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e8891a"]])

export default __exports__